import axios from "axios";
import Config from "src/config";

const v2_actionCheckInadimplencia = (id) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${id}/check-inadimplencia`
    });
};

export default v2_actionCheckInadimplencia;
